import { all } from 'redux-saga/effects'

import hocExportSaga from './components/HocExports/saga'

export default function* toolbarSaga() {
    yield all([hocExportSaga()])
}
